/**
 * The three HubSpot forms the captured site used, and where.
 *
 * The default was embedded in every page's <head> whether or not that page
 * showed a form; only these routes actually rendered a different one.
 *
 * Its own module so `HubSpotForm.tsx` exports only a component.
 */
export const HUBSPOT_PORTAL_ID = '45761690'
export const HUBSPOT_SCRIPT_SRC = 'https://js.hsforms.net/forms/embed/v2.js'

const DEFAULT_FORM_ID = 'df4a060e-c93d-4fdc-8c36-f37cec532acc'

/**
 * `/newsletter` and `/singulate-certified-partner-program` are deliberately
 * absent. Live posts both through the hubspotonwebflow.com bridge
 * (form ids 0b47679c-… and cd0e3175-…), which is a Webflow-only service and
 * has no HubSpot form GUID to map to. They need real HubSpot forms before
 * either route can capture a lead here.
 */

export const FORM_BY_ROUTE: Record<string, string> = {
  // Verified against live www.singulate.com on 2026-09-04.
  '/demo': 'f8cebf8a-e814-47ca-9b7b-e619afae78a7',
  '/try-singulate-for-free': '6516e18d-fc33-460e-9a9d-e94e124854fc',
  // Send Help (weekly live session) registration, created 2026-10-28.
  '/sendhelp': '466166ab-dffd-4db7-a130-f626df738e65',
  '/post/generative-ai-marketing-email-vs-sales-email': '2da14c86-1b9d-4d6a-949e-8ede75207ab4',
}

export function formIdForRoute(route: string): string {
  return FORM_BY_ROUTE[route] ?? DEFAULT_FORM_ID
}
